module.exports = __webpack_public_path__ + "static/media/icon.404c7967.png";